<template>
  <div>
    <v-layout row wrap align-center style="margin-top: 1%;">
      <v-flex class="text-xs-center">
    <v-card
      align-center
      max-width="1200"
      class="mx-auto elogCardBg"
    >
      <v-list-item :style="customercolors">
        <v-list-item-avatar :color="maincontrast"><v-icon :color="highlight">mdi-package-variant</v-icon></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="customheadline"> {{ttitem.RefNr}} <b style="font-size:20px;">/</b> {{ ttitem.LiefNr }} <b style="font-size:20px;">/</b> {{ ttitem.ERPAUFTNR }}</v-list-item-title>
          <v-list-item-subtitle :style="customercolors">Referenznummer / Lieferscheinnummer / ERPAuftragsnummer</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-text class="elogCardBg">
        <v-row sm="12" md="12" cols="12">
    <v-col class="mb-0 pb-0" cols="12" sm="12" md="5">
        <v-card
      align-center
      max-width="1200"
      class="mx-auto"
    >
      <v-list-item>
        <v-list-item-avatar :color="highlight"><v-icon :color="highlightcontrast">mdi-clock-start</v-icon></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="customheadline">{{ new Date(ttitem.LoadDate.To).toLocaleDateString() }}</v-list-item-title>
          <v-list-item-subtitle>Ladedatum</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider inset></v-divider>
      <v-list-item>
        <v-list-item-avatar :color="highlight"><v-icon :color="highlightcontrast">mdi-truck-delivery</v-icon></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="customheadline">{{ new Date(ttitem.DeliveryDate.To).toLocaleDateString() }}</v-list-item-title>
          <v-list-item-subtitle>Abladedatum</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider inset></v-divider>
      <v-list-item>
        <v-list-item-avatar :color="highlight"><v-icon :color="highlightcontrast">mdi-target</v-icon></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="customheadline">
            {{ ttitem.DeliveryAddress.Name1 }}<br>
            {{ ttitem.DeliveryAddress.Strasse}}<br>
            {{ ttitem.DeliveryAddress.Plz }} {{ ttitem.DeliveryAddress.Ort }}
          </v-list-item-title>
          <v-list-item-subtitle>Abladeadresse</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!---maybe used in a future version?
      <v-divider inset></v-divider>
      <v-list-item>
        <v-list-item-avatar color="orange"><v-icon color="gray">mdi-weight-kilogram</v-icon></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">{{ auft.Weight}}</v-list-item-title>
          <v-list-item-subtitle>Gewicht, brutto</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider inset></v-divider>
      <v-list-item>
        <v-list-item-avatar color="orange"><v-icon color="gray">mdi-note-plus</v-icon></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">{{ auft.LSBEM}}</v-list-item-title>
          <v-list-item-subtitle>Bemerkungen</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      -->
      <v-card-text>

      </v-card-text>
    </v-card>
    </v-col>
    <v-col class="mb-0 pb-0 " sm="12" md="7" cols="12">
      <v-timeline dense>
        <v-timeline-item
          v-for="item in ttitem.Status"
          :key="item.code"
          :right="true"
          :color="highlight"
        >
          <span slot="opposite">{{ item.Description.DE }}</span>
          <v-card class="elevation-2">
            <v-card-title :color="getColor(item.Code)" class="customheadline">{{ item.Description.DE }}</v-card-title>
            <v-card-text>
              {{ new Date(item.TimeStamp).toLocaleString() }}
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-col>
</v-row>
      </v-card-text>

      <v-card-actions>
        <!--<v-btn
          text
          color="blue"
        >
          Contact Transporteur
        </v-btn>-->
        <v-spacer></v-spacer>
        <!--<v-btn
          text
          color="blue"
          @click="redirectlogin"
        >
          Login Track and Trace
          <i><font color="red">e</font></i>Log Kundenportal
        </v-btn>-->
      </v-card-actions>
    </v-card>
    </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    ttitem: {
      get () {
        return this.$store.state.trackandtracedata
      }
    },
    ttresponsewatcher: {
      get () {
        return this.$store.state.ttresponsewatcher
      }
    },
    spedlogo: function () {
      return {
        'background-image': 'url(' + this.$store.state.ttlinkoptics.spedLogo + ')'
      }
    },
    customercolors: function () {
      return {
        'color': this.$store.state.ttlinkoptics.mainConstrastColor + '!important',
        'background-color': this.$store.state.ttlinkoptics.mainColor
      }
    },
    main: function () {
      return this.$store.state.ttlinkoptics.mainColor
    },
    maincontrast: function () {
      return this.$store.state.ttlinkoptics.mainConstrastColor
    },
    highlight: function () {
      return this.$store.state.ttlinkoptics.highlightColor
    },
    highlightcontrast: function () {
      return this.$store.state.ttlinkoptics.highlightContrastColor
    }
  },
  methods: {
    getColor (code) {
      if (code > 6) return 'green'
      else if (code > 2) return 'orange'
      else return 'red'
    },
    redirectlogin () {
      // this.$router.push({ path: '/' })
    }
  },
  watch: {
    ttresponsewatcher: function () {
      if (this.$store.state.ttresponsewatcher === true) { this.$router.push('nodata') }
    }
  }
}
</script>

<style>
  .elogCardBg{
    background-color: #424242 !important;
  }
  @media screen and (max-width: 2000px ){
    .customheadline {
      font-size: 1.5rem !important;
    }
  }
  @media screen and (max-width: 600px ){
    .customheadline {
      font-size: 0.9rem !important;
      line-height: 1rem !important;
      font-weight: 600;
    }
  }

</style>
